import axios from 'axios';

const URL = process.env.REACT_APP_API_URI + 'all-inclusive-stats/';

const fetchAllInclusiveStats = async () => {
  const response = await axios.get(URL);
  return response.data;
};

const actions = {
  fetchAllInclusiveStats,
};

export default actions;
